import Footer from "./Footer";
import Background from "./Background";
import Header from "./Header";
import ErrorContent from "./ErrorContent";

type GeneralErrorLayoutProps = React.PropsWithChildren<{
  withoutHeader?: boolean;
}>;

const GeneralErrorLayout = (props: GeneralErrorLayoutProps) => {
  return (
    <>
      <Background />
      {!props.withoutHeader && <Header />}

      <div className="main-container wider" id="main-container">
        <ErrorContent>{props.children}</ErrorContent>
      </div>

      <Footer />
    </>
  );
};

export default GeneralErrorLayout;
